import React, { Component } from 'react'

import Terms from './components/Terms'

export const NAME = 'PRIVACY_POLICY'
export const BACKEND_IDENTIFIER = 'P'

class PrivacyPolicy extends Component {
  render() {
    return (
      <Terms
        type={BACKEND_IDENTIFIER}
        name={NAME}
        onHeight={this.props.onHeight}
      />
    )
  }
}

export default PrivacyPolicy
